export const WorkAloneCommunicationMethod = {
    Phone: 'Phone',
    Radio: 'Radio',
    Visual: 'Visual',
} as const

export type WorkAloneCommunicationMethod = (typeof WorkAloneCommunicationMethod)[keyof typeof WorkAloneCommunicationMethod]

export class SafetyWorkAloneAuth {
    id!: string
    indexId!: number
    employeeHrRef?: number | null
    workDate?: Date | string | null
    siteLocation?: string | null
    jobDescription?: string | null
    weekendWork = false
    lengthOfTime?: string | null
    emergencyContact1?: string | null
    emergencyContact2?: string | null
    emergencyContact3?: string | null
    communicationMethod?: WorkAloneCommunicationMethod | string | null
    employeeSignature?: string | null
    signedOn?: Date | string | null
    supervisorNotified = false
    safetyManagerNotified = false
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean
    imageUrls: string[] = []
    imageFileNames: string[] = []

    static createNew(): SafetyWorkAloneAuth {
        const item = new SafetyWorkAloneAuth()
        item.id = crypto.randomUUID()
        return item
    }
}
